import styled from 'styled-components';
import { Layout, Tooltip } from 'antd';
export const ChildrenContainer = styled.div`
	background: #fff;
	position: relative;
	margin-top: 0.9375rem;
	min-height: 70vh;
	padding: 0.625rem;
`;

export const ContainerChildren = styled.div`
	position: relative;
	margin-top: 0.9375rem;
	min-height: 70vh;
	padding: 0.625rem;
`;

export const SiderMenuContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: #fff;
	height: 100%;
	position: relative;
`;

export const SiderMenuContainerDivider = styled.div`
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const SiderMenuContainerDividerSandbox = styled.div`
	flex: 0 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.625rem;
	padding: 0.75rem 0;
	border-top: 0.0625rem solid #f0f0f0;
`;

export const CustomLayout = styled(Layout)`
	overflow: hidden;
	min-height: calc(100vh - 5rem);

	@media (max-width: 43.75rem) {
		width: 43.75rem;
		overflow: scroll;
	}
`;

export const LayoutContent = styled(Layout)<{ $siderCollapsed: boolean }>`
	transition: all 0.2s;
	margin-top: 5rem;
	margin-left: ${({ $siderCollapsed }) => ($siderCollapsed ? '5rem' : '15.625rem')};
	min-height: calc(100vh - 5rem);
	height: 100%;
	z-index: 999;
	width: calc(100vw - 17.5rem);
	min-width: 43.75rem;
	overflow: auto;

	@media (max-width: 43.75rem) {
		width: 43.75rem;
		overflow-y: scroll;
		overflow-x: hidden;
	}
`;

export const CustomSider = styled(Layout.Sider).attrs({ theme: 'light' })`
	position: fixed;
	top: 5rem;
	left: 0;
	height: calc(100vh - 5rem);
	transition: all 0.2s;
	z-index: 1000;

	@media (max-width: 43.75rem) {
		width: 43.75rem;
		height: calc(100vh - 5rem);
	}
`;

export const SandboxTooltip = styled(Tooltip)<{ siderCollapsed: boolean }>`
	display: flex;
	flex-direction: ${({ siderCollapsed }) => (siderCollapsed ? 'column-reverse' : 'row')};
	gap: 0.625rem;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
`;

export const SandboxLabel = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
